module.exports = __webpack_public_path__ + "img/177.desserts.9de1ac8a.svg";